import { useDefectLegendsForEquipmentQuery } from '@/__generated__/graphql';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useEffect, useState } from 'react';

type DefectLegendColors = Record<string, string>;

export const useDefectLegendColors = () => {
  const [defectLegendColors, setDefectLegendColors] = useState<DefectLegendColors>({});
  const structureId = useGetStructureId();
  const { data, loading } = useDefectLegendsForEquipmentQuery({
    variables: { structureId },
    skip: !structureId,
  });

  useEffect(() => {
    const defectLegends = data?.structure?.defectLegends;
    if (defectLegends) {
      const colors = defectLegends.reduce<DefectLegendColors>((accumulator, current) => {
        accumulator[current.name] = current.color;
        return accumulator;
      }, {});
      setDefectLegendColors(colors);
    }
  }, [data]);

  return { defectLegendColors, loading };
};
